export function addItem(array, item) {
	return [...array, item];
}

export function removeItem(array, item) {
	const index = array.indexOf(item);
	return [...array.slice(0, index), ...array.slice(index + 1)];
}

export function toggleItem(array, item) {
	const toggleFunction = array.includes(item) ? removeItem : addItem;
	return toggleFunction(array, item);
}



// WEBPACK FOOTER //
// ./src/js/utils/immutability-helpers.js